/* global axios */
import ApiClient from '../../ApiClient';

class VoiceCallsAPI extends ApiClient {
  constructor() {
    super('voice/calls', { accountScoped: true });
  }

  originate({ conversationId }) {
    return axios.post(this.url, { conversation_id: conversationId });
  }

  transfer(uniqueId, { targetAgentId }) {
    return axios.post(`${this.url}/${uniqueId}/transfer`, {
      target_agent_id: targetAgentId,
    });
  }

  context(uniqueId) {
    return axios.get(`${this.url}/${uniqueId}/context`);
  }
}

export default new VoiceCallsAPI();
